import { curryActionForPath } from 'helpers/curry'

import {
    downloadDataRequest,
    fetchDataRequest,
    fetchDataSuccess,
    updateSorter,
} from './data'

export const makeUpdateListSorter = curryActionForPath(updateSorter)

export const makeFetchListRequest = curryActionForPath(fetchDataRequest)
export const makeFetchListSuccess = curryActionForPath(fetchDataSuccess)
export const makeDownloadListRequest = curryActionForPath(downloadDataRequest)
